import { getWeblinkFromPublicId } from 'reactApp/modules/file/utils';

export const getFacesFileId = (id: string) => {
    return id.replace(getWeblinkFromPublicId(id) ?? '', '');
};
